import { formatInTimeZone, zonedTimeToUtc } from 'date-fns-tz';
import { AddClassInput, ClassType } from 'generated/graphql';
import { RRule } from 'rrule';
import { AugmentedClass, IForm } from './types';

// deserialize
export const clsToFormData = (
  cls: AugmentedClass,
  isDuplicate = false,
): IForm => {
  return {
    name: (isDuplicate ? 'Duplicate: ' : '') + (cls.name ?? ''),
    description: cls.description ?? '',
    color: cls.color,
    date: formatInTimeZone(cls.dtstart, 'America/New_York', 'yyyy-MM-dd'),
    time: formatInTimeZone(cls.dtstart, 'America/New_York', 'HH:mm'),
    duration: cls.duration ? '' + cls.duration : '',
    type: cls.type,
    cover: {
      cdn01: cls.cover.cdn01,
      image: cls.cover.image,
    },
    location: cls.location,
    category: cls.category,
    difficulty: cls.difficulty,
  };
};

// serialize
export const formDataToMutationData = (
  influencerId,
  formData: IForm,
): AddClassInput & { influencerId: number } => {
  const year = +formData.date.slice(0, 4);
  const month = +formData.date.slice(5, 7) - 1;
  const day = +formData.date.slice(8, 10);

  const hour = +formData.time.slice(0, 2);
  const minute = +formData.time.slice(3, 5);

  const date = new Date(year, month, day, hour, minute);

  return {
    influencerId,
    name: formData.name,
    description: formData.description,
    duration: formData.duration ? +formData.duration : null,
    type: formData.type as ClassType,
    color: formData.color,
    schedule: new RRule({
      dtstart: new Date(zonedTimeToUtc(date, 'America/New_York')),
    }).toString(),
    cover: {
      cdn01: formData.cover.cdn01,
      image: formData.cover.image,
    },
    location: formData.location,
    category: formData.category,
    difficulty: formData.difficulty,
  };
};
